import { render } from "./electivView.vue?vue&type=template&id=01f1742e"
import script from "./electivView.vue?vue&type=script&lang=js"
export * from "./electivView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__